export default __webpack_public_path__ + "static/media/Housing.fa2a6270.png";